import {useMemo} from 'react';

import {view} from '@sail/ui';
import {parsePhoneNumberWithError} from 'libphonenumber-js';

export const UserInfo = ({
  userName,
  userPhoneNumber,
}: {
  userName: string;
  userPhoneNumber: string;
}) => {
  const formattedPhoneNumber = useMemo(() => {
    try {
      const phoneNumber = parsePhoneNumberWithError(userPhoneNumber);
      return `+${
        phoneNumber.countryCallingCode
      } ${phoneNumber.formatNational()}`;
    } catch (error) {
      // Swallow parsing error and fallback to rendering the number as-is
    }
    return userPhoneNumber;
  }, [userPhoneNumber]);

  return (
    <view.div
      css={{stack: 'x', distribute: 'space-between', marginY: 'medium'}}
    >
      <view.span css={{font: 'label.small.emphasized'}}>{userName}</view.span>
      <view.span css={{font: 'label.small'}}>{formattedPhoneNumber}</view.span>
    </view.div>
  );
};
